import { render, staticRenderFns } from "./ScanQrCode.vue?vue&type=template&id=060d1878&scoped=true"
import script from "./ScanQrCode.vue?vue&type=script&lang=js"
export * from "./ScanQrCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060d1878",
  null
  
)

export default component.exports